import FontAwesomeIcon from "./FontAwesomeIcon";

export default function EyeIcon({ ...props }) {
  return <FontAwesomeIcon name="eye" {...props} />;
}
